import { render, staticRenderFns } from "./BillsImport.vue?vue&type=template&id=b5bd8076&scoped=true"
import script from "./BillsImport.vue?vue&type=script&lang=js"
export * from "./BillsImport.vue?vue&type=script&lang=js"
import style0 from "./BillsImport.vue?vue&type=style&index=0&id=b5bd8076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bd8076",
  null
  
)

export default component.exports